import React from 'react';
import { Order } from '../interfaces';
import DiscountValuePad from './DiscountValuePad';

interface AddOrderDiscountValueProps {
    order: Order | any;
    onClose: () => void;
    onDiscountSubmit: (value: number, discountType: string, discountName?: string) => void;
}

const AddOrderDiscountValue: React.FC<AddOrderDiscountValueProps> = ({ onClose, order, onDiscountSubmit }) => {
    return (
        <DiscountValuePad
            title="Add discount"
            subtitle="Whole order"
            initialValue={order?.orderDiscountValue ?? order?.discount}
            initialType={order?.orderDiscountType}
            initialName={order?.orderDiscountName}
            onClose={onClose}
            onSubmit={onDiscountSubmit}
        />
    );
};

export default AddOrderDiscountValue;
